/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: routes.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:56
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import OnlineUserManager from "../security/OnlineUserManager";
import {RouterNameDefineEnum, RouterPathDefineEnum} from "./RouterDefine";

export default [

    // ------------------------------ dashboard ------------------------------
    {
        path: RouterPathDefineEnum.Dashboard,
        name: RouterNameDefineEnum.Dashboard,
        meta: {authRequired: true},
        component: () => import("../mvc/views/dashboards/default"),
    },
    // ------------------------------ user ------------------------------
    {
        path: RouterPathDefineEnum.UserList,
        name: RouterNameDefineEnum.UserList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/users/list.vue"),
    },
    {
        path: RouterPathDefineEnum.UserAdd,
        name: RouterNameDefineEnum.UserAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/users/form.vue"),
    },
    {
        path: RouterPathDefineEnum.UserEdit,
        name: RouterNameDefineEnum.UserDetail,
        meta: {authRequired: true},
        component: () => import("../mvc/views/users/detail.vue"),
    },
    // ------------------------------ device req policy ------------------------------
    {
        path: RouterPathDefineEnum.DevReqList,
        name: RouterNameDefineEnum.DevReqList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/device-requirement-policy/list.vue"),
    },
    {
        path: RouterPathDefineEnum.DevReqAdd,
        name: RouterNameDefineEnum.DevReqAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/device-requirement-policy/form.vue"),
    },
    {
        path: RouterPathDefineEnum.DevReqEdit,
        name: RouterNameDefineEnum.DevReqEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/device-requirement-policy/form.vue"),
    },
    // ------------------------------ group ------------------------------
    {
        path: RouterPathDefineEnum.GroupList,
        name: RouterNameDefineEnum.GroupList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/groups/list.vue"),
    },
    {
        path: RouterPathDefineEnum.GroupAdd,
        name: RouterNameDefineEnum.GroupAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/groups/form.vue"),
    },
    {
        path: RouterPathDefineEnum.GroupEdit,
        name: RouterNameDefineEnum.GroupEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/groups/form.vue"),
    },
    // ------------------------------  device ------------------------------
    {
        path: RouterPathDefineEnum.DevicesList,
        name: RouterNameDefineEnum.DevicesList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/devices/list"),
    },
    {
        path: RouterPathDefineEnum.DeviceEdit,
        name: RouterNameDefineEnum.DeviceEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/devices/details"),
    },
    // ------------------------------ resource ------------------------------
    {
        path: RouterPathDefineEnum.ResourceList,
        name: RouterNameDefineEnum.ResourceList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resources/list"),
    },
    {
        path: RouterPathDefineEnum.ResourceAdd,
        name: RouterNameDefineEnum.ResourceAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resources/form.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceEdit,
        name: RouterNameDefineEnum.ResourceEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resources/form.vue"),
    },
    // ------------------------------ secure network ------------------------------
    {
        path: RouterPathDefineEnum.SecureList,
        name: RouterNameDefineEnum.SecureList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/secure-network/list"),
    },
    {
        path: RouterPathDefineEnum.SecureNetWorkAdd,
        name: RouterNameDefineEnum.SecureNetWorkAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/secure-network/form.vue"),
    },
    {
        path: RouterPathDefineEnum.SecureNetWorkEdit,
        name: RouterNameDefineEnum.SecureNetWorkEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/secure-network/form.vue"),
    },
    // ------------------------------ saved policy ------------------------------
    {
        path: RouterPathDefineEnum.SavedPolicyList,
        name: RouterNameDefineEnum.SavedPolicyList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-policy/list"),
    },
    {
        path: RouterPathDefineEnum.SavedPolicyAdd,
        name: RouterNameDefineEnum.SavedPolicyAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-policy/form.vue"),
    },
    {
        path: RouterPathDefineEnum.SavedPolicyEdit,
        name: RouterNameDefineEnum.SavedPolicyEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-policy/form.vue"),
    },
    // ------------------------------ role and admin ------------------------------
    {
        path: RouterPathDefineEnum.RolesList,
        name: RouterNameDefineEnum.RolesList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/list.vue"),
    },
    {
        path: RouterPathDefineEnum.RolesAdd,
        name: RouterNameDefineEnum.RolesAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/form.vue"),
    },
    {
        path: RouterPathDefineEnum.RolesEdit,
        name: RouterNameDefineEnum.RolesEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/form.vue"),
    },
    {
        path: RouterPathDefineEnum.AssignRole,
        name: RouterNameDefineEnum.AssignRole,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/assign-role.vue"),
    },
    {
        path: RouterPathDefineEnum.ViewAssignee,
        name: RouterNameDefineEnum.ViewAssignee,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/view-assignee.vue"),
    },
    {
        path: RouterPathDefineEnum.ViewGranter,
        name: RouterNameDefineEnum.ViewGranter,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/view-granters.vue"),
    },
    {
        path: RouterPathDefineEnum.ViewAssignment,
        name: RouterNameDefineEnum.ViewAssignment,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/view-assignment.vue"),
    },
    {
        path: RouterPathDefineEnum.ViewGrantDetails,
        name: RouterNameDefineEnum.ViewGrantDetails,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/view-grant-details.vue"),
    },
    {
        path: RouterPathDefineEnum.UserReceivedRolesList,
        name: RouterNameDefineEnum.UserReceivedRolesList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/user-received-roles.vue"),
    },
    {
        path: RouterPathDefineEnum.ReceivedRolesList,
        name: RouterNameDefineEnum.ReceivedRolesList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/user-received-roles.vue"),
    },
    {
        path: RouterPathDefineEnum.CurrentUserRoles,
        name: RouterNameDefineEnum.CurrentUserRoles,
        meta: {authRequired: true},
        component: () => import("../mvc/views/security-role/user-received-roles.vue"),
        redirect: () => {
            const userInfo = OnlineUserManager.Instance.get()?.userInfo;
            if (userInfo?.userId && userInfo?.email) {
                return {
                    name: RouterNameDefineEnum.UserReceivedRolesList,
                    params: {
                        userId: userInfo.userId,
                        userEmail: userInfo.email
                    }
                };
            }
            return {path: RouterPathDefineEnum.RolesList};
        }
    },
    // ------------------------------ geo proxy policy ------------------------------
    {
        path: RouterPathDefineEnum.GeoProxyPolicy,
        name: RouterNameDefineEnum.GeoProxyPolicy,
        meta: {authRequired: true},
        component: () => import("../mvc/views/geo-proxy-policy/list.vue"),
    },
    {
        path: RouterPathDefineEnum.GeoProxyPolicyAdd,
        name: RouterNameDefineEnum.GeoProxyPolicyAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/geo-proxy-policy/form.vue"),
    },
    {
        path: RouterPathDefineEnum.GeoProxyPolicyEdit,
        name: RouterNameDefineEnum.GeoProxyPolicyEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/geo-proxy-policy/form.vue"),
    },
    //  ------------------------------ resource section ------------------------------
    {
        path: RouterPathDefineEnum.ResourceSectionList,
        name: RouterNameDefineEnum.ResourceSectionList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-sections/list.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceSectionAdd,
        name: RouterNameDefineEnum.ResourceSectionAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-sections/form.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceSectionEdit,
        name: RouterNameDefineEnum.ResourceSectionEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/resource-sections/form.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceSectionIdentities,
        name: RouterNameDefineEnum.ResourceSectionIdentities,
        component: () => import("../mvc/views/resource-sections/res-section-identities-list.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceSectionRoles,
        name: RouterNameDefineEnum.ResourceSectionRoles,
        component: () => import("../mvc/views/resource-sections/res-section-roles-list.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceSectionRolesCreate,
        name: RouterNameDefineEnum.ResourceSectionRolesCreate,
        component: () => import("../mvc/views/resource-sections/role-form.vue"),
    },
    // ------------------------------ location ------------------------------
    {
        path: RouterPathDefineEnum.LocationList,
        name: RouterNameDefineEnum.LocationList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/locations/list"),
    },
    {
        path: RouterPathDefineEnum.LocationEdit,
        name: RouterNameDefineEnum.LocationEdit,
        component: () => import("../mvc/views/locations/form.vue"),
    },
    {
        path: RouterPathDefineEnum.LocationAdd,
        name: RouterNameDefineEnum.LocationAdd,
        meta: {authRequired: false},
        component: () => import("../mvc/views/locations/form.vue"),
    },
    // ------------------------------ network access policy ------------------------------
    {
        path: RouterPathDefineEnum.PolicyList,
        name: RouterNameDefineEnum.PolicyList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/network-access-policy/list.vue"),
    },
    {
        path: RouterPathDefineEnum.AccessPolicyAdd,
        name: RouterNameDefineEnum.PolicyAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/network-access-policy/form.vue"),
    },
    {
        path: RouterPathDefineEnum.AccessPolicyEdit,
        name: RouterNameDefineEnum.PolicyEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/network-access-policy/form.vue"),
    },
    // ------------------------------ predefined list ------------------------------
    {
        path: RouterPathDefineEnum.IpMacList,
        name: RouterNameDefineEnum.IpMacList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/ip-mac-list/list.vue"),
    },
    {
        path: RouterPathDefineEnum.IpMacListAdd,
        name: RouterNameDefineEnum.IpMacListAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/ip-mac-list/form.vue"),
    },
    {
        path: RouterPathDefineEnum.IpMacListEdit,
        name: RouterNameDefineEnum.IpMacListEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/ip-mac-list/form.vue"),
    },
    {
        path: RouterPathDefineEnum.DeviceIdList,
        name: RouterNameDefineEnum.DeviceIdList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/device-id-list/list.vue"),
    },
    {
        path: RouterPathDefineEnum.DeviceListAdd,
        name: RouterNameDefineEnum.DeviceListAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/device-id-list/form.vue"),
    },
    {
        path: RouterPathDefineEnum.DeviceListEdit,
        name: RouterNameDefineEnum.DeviceListEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/device-id-list/form.vue"),
    },
    {
        path: RouterPathDefineEnum.LoginIdList,
        name: RouterNameDefineEnum.LoginIdList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/login-id-list/list.vue"),
    },
    {
        path: RouterPathDefineEnum.LoginListAdd,
        name: RouterNameDefineEnum.LoginListAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/login-id-list/form.vue"),
    },
    {
        path: RouterPathDefineEnum.LoginListEdit,
        name: RouterNameDefineEnum.LoginListEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/predefine/login-id-list/form.vue"),
    },
    // ------------------------------ uGate ------------------------------
    {
        path: RouterPathDefineEnum.UGateList,
        name: RouterNameDefineEnum.UGateList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/ugate/list.vue"),
    },
    {
        path: RouterPathDefineEnum.UGateAdd,
        name: RouterNameDefineEnum.UGateAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/ugate/form.vue"),
    },
    {
        path: RouterPathDefineEnum.UGateEdit,
        name: RouterNameDefineEnum.UGateEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/ugate/form.vue"),
    },
    // ------------------------------ connector ------------------------------
    {
        path: RouterPathDefineEnum.ConnectorList,
        name: RouterNameDefineEnum.ConnectorList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/connector/list"),
    },
    {
        path: RouterPathDefineEnum.ConnectorAdd,
        name: RouterNameDefineEnum.ConnectorAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/connector/form.vue"),
    },
    {
        path: RouterPathDefineEnum.ConnectorEdit,
        name: RouterNameDefineEnum.ConnectorEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/connector/form.vue"),
    },
    // ------------------------------ client agent setting ------------------------------
    {
        path: RouterPathDefineEnum.ClientAgent,
        name: RouterNameDefineEnum.ClientAgent,
        meta: {authRequired: true},
        component: () => import("../mvc/views/client-agent/client-agent.vue"),
    },
    // ------------------------------ team setting ------------------------------
    {
        path: RouterPathDefineEnum.TeamSetting,
        name: RouterNameDefineEnum.TeamSetting,
        meta: {authRequired: true},
        component: () => import("../mvc/views/team-setting/setting-team.vue"),
    },
    // ------------------------------ idp integration ------------------------------
    {
        path: RouterPathDefineEnum.IdPIntegration,
        name: RouterNameDefineEnum.IdPIntegration,
        meta: {authRequired: true},
        component: () => import("../mvc/views/idp-integration/list.vue"),
    },
    {
        path: RouterPathDefineEnum.MicrosoftIdpAdd,
        name: RouterNameDefineEnum.MicrosoftIdpAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/idp-integration/form.vue"),
    },
    {
        path: RouterPathDefineEnum.GoogleIdpAdd,
        name: RouterNameDefineEnum.GoogleIdpAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/idp-integration/form.vue"),
    },
    {
        path: RouterPathDefineEnum.GithubIdpAdd,
        name: RouterNameDefineEnum.GithubIdpAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/idp-integration/form.vue"),
    },
    {
        path: RouterPathDefineEnum.IdpEdit,
        name: RouterNameDefineEnum.IdpEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/idp-integration/form.vue"),
    },
    // ------------------------------ client application ------------------------------
    {
        path: RouterPathDefineEnum.ClientList,
        name: RouterNameDefineEnum.ClientList,
        meta: {authRequired: true},
        component: () => import("../mvc/views/client-application/list"),
    },
    {
        path: RouterPathDefineEnum.ClientApplicationAdd,
        name: RouterNameDefineEnum.ClientApplicationAdd,
        meta: {authRequired: true},
        component: () => import("../mvc/views/client-application/form.vue"),
    },
    {
        path: RouterPathDefineEnum.ClientApplicationEdit,
        name: RouterNameDefineEnum.ClientApplicationEdit,
        meta: {authRequired: true},
        component: () => import("../mvc/views/client-application/form.vue"),
    },
    // ------------------------------ sys log ------------------------------
    {
        path: RouterPathDefineEnum.UserLog,
        name: RouterNameDefineEnum.UserLog,
        meta: {authRequired: true},
        component: () => import("../mvc/views/logs/log-user-list.vue"),
    },
    {
        path: RouterPathDefineEnum.DeviceLog,
        name: RouterNameDefineEnum.DeviceLog,
        meta: {authRequired: true},
        component: () => import("../mvc/views/logs/log-device-list.vue"),
    },
    {
        path: RouterPathDefineEnum.ResourceLog,
        name: RouterNameDefineEnum.ResourceLog,
        meta: {authRequired: true},
        component: () => import("../mvc/views/logs/log-resource-list.vue"),
    },
    // ------------------------------ my menu ------------------------------
    {
        path: RouterPathDefineEnum.Profile,
        name: RouterNameDefineEnum.Profile,
        meta: {authRequired: false},
        component: () => import("../mvc/views/my-menu/profile.vue"),
    },
    // ------------------------------ otp ------------------------------
    {
        path: RouterPathDefineEnum.OtpAcquire,
        name: RouterNameDefineEnum.OtpAcquire,
        meta: {authRequired: true, hideLayout: true},
        component: () => import("../mvc/views/otp/otp-acquire.vue"),
    },
    // ------------------------------ totp ------------------------------
    {
        path: RouterPathDefineEnum.TotpAuth,
        name: RouterNameDefineEnum.TotpAuth,
        component: () => import('@/mvc/views/totp/form.vue')
    },
    {
        path: RouterPathDefineEnum.RecoveryCodes,
        name: RouterNameDefineEnum.RecoveryCodes,
        component: () => import('@/mvc/views/totp/recovery-code.vue')
    },
    {
        path: RouterPathDefineEnum.RecoveryCodesView,
        name: RouterNameDefineEnum.RecoveryCodesView,
        component: () => import('@/mvc/views/totp/recovery-code.vue')
    },
    {
        path: RouterPathDefineEnum.RecoveryCodesPrint,
        name: RouterNameDefineEnum.RecoveryCodesPrint,
        meta: {authRequired: true},
        component: () => import('@/mvc/views/totp/recovery-code-print.vue')
    },
    // ------------------------------ notification ------------------------------
    {
        path: RouterPathDefineEnum.NotificationList,
        name: RouterNameDefineEnum.NotificationList,
        component: () => import('@/mvc/views/notification/notification-inbox-list.vue')
    },
    {
        path: RouterPathDefineEnum.NotificationDetail,
        name: RouterNameDefineEnum.NotificationDetail,
        component: () => import('@/mvc/views/notification/notification-inbox-detail.vue')
    },
    // ------------------------------ error ------------------------------
    {
        path: RouterPathDefineEnum.Error403,
        name: RouterNameDefineEnum.Error403,
        meta: {authRequired: false},
        component: () => import("../mvc/views/utility/403"),
    },
    {
        path: RouterPathDefineEnum.Error404,
        name: RouterNameDefineEnum.Error404,
        meta: {authRequired: false},
        component: () => import("../mvc/views/utility/404"),
    },
    {
        path: RouterPathDefineEnum.Error500,
        name: RouterNameDefineEnum.Error500,
        meta: {authRequired: false},
        component: () => import("../mvc/views/utility/500"),
    },
    // ------------------------------------------------------------------------------------
    // test page(s) — development builds only, never shipped to production
    // ------------------------------------------------------------------------------------
    ...(process.env.NODE_ENV === 'production' ? [] : [
        {
            path: "/teamData",
            name: "teamData",
            meta: {authRequired: false},
            component: () => import("../mvc/views/teamData.vue"),
        },
        {
            path: "/test/parent",
            name: "parent",
            meta: {authRequired: false},
            component: () => import("../mvc/views/test/parent"),
        },
        {
            path: "/components",
            name: "components-index",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/index.vue"),
        },
        {
            path: "/components/buttons",
            name: "components-buttons",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/buttons.vue"),
        },
        {
            path: "/components/chips",
            name: "components-chips",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/chips.vue"),
        },
        {
            path: "/components/switch",
            name: "components-switch",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/switch.vue"),
        },
        {
            path: "/components/progress",
            name: "components-progress",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/progress.vue"),
        },
        {
            path: "/components/feedback",
            name: "components-feedback",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/feedback.vue"),
        },
        {
            path: "/components/dialog",
            name: "components-dialog",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/dialog.vue"),
        },
        {
            path: "/components/search",
            name: "components-search",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/search.vue"),
        },
        {
            path: "/components/text-fields",
            name: "components-text-fields",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/text-fields.vue"),
        },
        {
            path: "/components/selection",
            name: "components-selection",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/selection.vue"),
        },
        {
            path: "/components/lists",
            name: "components-lists",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/lists.vue"),
        },
        {
            path: "/components/plane-row",
            name: "components-plane-row",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/plane-row.vue"),
        },
        {
            path: "/components/sheet",
            name: "components-sheet",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/sheet.vue"),
        },
        {
            path: "/components/stepper",
            name: "components-stepper",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/stepper.vue"),
        },
        {
            path: "/components/otp",
            name: "components-otp",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/otp.vue"),
        },
        {
            path: "/components/qr",
            name: "components-qr",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/qr.vue"),
        },
        {
            path: "/components/copy-reveal",
            name: "components-copy-reveal",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/copy-reveal.vue"),
        },
        {
            path: "/components/menu",
            name: "components-menu",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/menu-surface.vue"),
        },
        {
            path: "/components/colour",
            name: "components-colour",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/colour.vue"),
        },
        {
            path: "/components/type",
            name: "components-type",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/type.vue"),
        },
        {
            path: "/components/type-classes",
            name: "components-type-classes",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/type-classes.vue"),
        },
        {
            path: "/components/shape",
            name: "components-shape",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/shape.vue"),
        },
        {
            path: "/components/scales",
            name: "components-scales",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/scales.vue"),
        },
        {
            path: "/components/overlay",
            name: "components-overlay",
            meta: {authRequired: false},
            component: () => import("../mvc/views/components/overlay.vue"),
        },
    ]),
    // catch-all: any unknown URL renders the 404 page instead of a blank router-view
    {
        path: "/:pathMatch(.*)*",
        meta: {authRequired: false},
        component: () => import("../mvc/views/utility/404"),
    },
];